import { compose } from 'lodash/fp';
import { connect } from 'react-redux';
import { fetchCurrentEnterpriseCheckedReservations } from '../../actions';
import withReservationsSameService from '../withReservationsSameService';

export default compose(
    // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
    connect(null, (dispatch, { scope }) => ({
        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
        refetchGroup: () => dispatch(fetchCurrentEnterpriseCheckedReservations({ scope })),
    })),
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    withReservationsSameService
);
